import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-info-candidate-resume',
  imports: [CommonModule],
  templateUrl: './info-candidate-resume.html',
  styleUrl: './info-candidate-resume.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoCandidateResume {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  status!: string | null;

  ngOnInit(): void {
    this.status = this.route.snapshot.queryParamMap.get('status');
    if (!this.status || (this.status !== '1' && this.status !== '2')) {
      this.router.navigate(['/login']);
    }
  }
}
